import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=1c9fd082&scoped=true&"
import script from "./Logistics.vue?vue&type=script&lang=ts&"
export * from "./Logistics.vue?vue&type=script&lang=ts&"
import style0 from "./Logistics.vue?vue&type=style&index=0&id=1c9fd082&scoped=true&lang=scss&"
import style1 from "./Logistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fd082",
  null
  
)

export default component.exports